import React from 'react'
import PropTypes from 'prop-types'

import UploadFileButton from 'components/UploadFileButton'
import { useMappingAPI, getErrorMessage } from '../helpers'

const MAX_CHUNK_SIZE = 2 * 1024

const UploadStudentData = ({ onUploadSuccess, disabled }) => {
  const API = useMappingAPI()
  return (
    <UploadFileButton
      label="Upload Student Data"
      disabled={disabled}
      dataField="DataFile"
      acceptedFileType=".csv"
      postApiEndpoint={API}
      onUploadSuccess={onUploadSuccess}
      getErrorMessage={getErrorMessage}
      onPreprocessFile={(file) => file.slice(0, MAX_CHUNK_SIZE)}
    />
  )
}

UploadStudentData.propTypes = {
  onUploadSuccess: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
}

export default UploadStudentData
